import { render, staticRenderFns } from "./shoes.vue?vue&type=template&id=3fc54303&"
import script from "./shoes.vue?vue&type=script&lang=js&"
export * from "./shoes.vue?vue&type=script&lang=js&"
import style0 from "./shoes.vue?vue&type=style&index=0&lang=css&"
import style1 from "./shoes.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports